import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { Button, Notice, Separator, Text } from '@teliaee/design-system';
import LoginButton from '../components/LoginButton';
import useStores from '../stores/UseStores';
import { FetchStatus } from '../util/ApiUtil';
import { isWebAuthSupported } from '../util/BrowserUtil';

const PasskeyLogin = observer((): React.JSX.Element => {
  const {
    uiStore: { setSelectedTab },
    smartIdLoginStore,
    mobileIdLoginStore,
    passkeyStore,
    translateStore: { translate },
  } = useStores();

  const [showPasskeyLoginView, setShowPasskeyLoginView] = useState(passkeyStore.getPasskeyExists());

  if (!isWebAuthSupported()) {
    return (
      <Text>
        <Notice type="attention">{translate('passkey.login.webAuthNotSupported')}</Notice>
      </Text>
    );
  }

  if (showPasskeyLoginView) {
    return (
      <Text>
        <Separator />
        <LoginButton
          isLoading={passkeyStore.status === FetchStatus.FETCHING}
          onClick={() => {
            passkeyStore.authenticate();
          }}
        />
        <Button link={true} text={translate('passkey.add.new')} onClick={() => setShowPasskeyLoginView(false)} />
      </Text>
    );
  }

  return (
    <Text>
      <Separator />
      <Button
        block={true}
        text={translate('passkey.bind.with.mobileId')}
        iconRight="#arrow-right"
        onClick={() => {
          setSelectedTab('mobileId');
          mobileIdLoginStore.shouldSavePasskeyAfterLogin = true;
        }}
      />
      <Button
        block={true}
        text={translate('passkey.bind.with.smartId')}
        iconRight="#arrow-right"
        onClick={() => {
          setSelectedTab('smartId');
          smartIdLoginStore.shouldSavePasskeyAfterLogin = true;
        }}
      />
      <Notice size="small" type="info">
        {translate('passkey.login.notice')}
      </Notice>
      <Button
        link={true}
        text={translate('passkey.login.with.passkey')}
        onClick={() => {
          setShowPasskeyLoginView(true);
          passkeyStore.authenticate();
        }}
        iconRight="#arrow-right"
      />
    </Text>
  );
});

export default PasskeyLogin;
